import { render, staticRenderFns } from "./questionCircleV1Icon.vue?vue&type=template&id=a3f252bc&"
import script from "./questionCircleV1Icon.vue?vue&type=script&lang=js&"
export * from "./questionCircleV1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports